module.exports = ".wrapper {\n  display: flex;\n  align-items: center;\n  flex-direction: column; }\n"